var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConstructedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "144px",
    viewBox: "0 0 120 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "VECTOR - Constructed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.5437204,3.73521728 C33.8385138,0.603818174 28.9608288,-0.642248041 24.163929,0.315532415 C17.7060181,1.60470155 12.5193839,7.19520618 11.5510521,13.9108649 C10.7612121,19.3910933 12.6596665,24.8640445 16.6296087,28.5518631 C18.4183479,30.2132847 19.4974866,32.6063364 19.6688824,35.2910325 C19.6721575,35.3397332 19.6814369,35.3867546 19.691808,35.4332162 L19.691808,43.8517201 C19.691808,44.3152165 20.058071,44.6913874 20.5105779,44.6913874 L21.3266185,44.6913874 C21.6590391,47.1314605 23.4079315,49 25.5143535,49 L29.2315687,49 C31.3379907,49 33.0863373,47.1314605 33.4187578,44.6913874 L34.2347985,44.6913874 C34.6867594,44.6913874 35.0535683,44.3152165 35.0535683,43.8517201 L35.0535683,35.2988694 C35.0535683,35.2971901 35.0541142,35.2955107 35.0541142,35.2932716 C35.0541142,32.7955414 36.1599994,30.3834573 38.1687148,28.501483 C41.4776368,25.4014315 43.375,20.9920588 43.375,16.4046767 C43.3755453,11.4853461 41.2500187,6.86717617 37.5437204,3.73521728 Z M24.4777908,19.6709823 L23.2196144,19.6709823 C22.5258434,19.6709823 21.9614381,19.0921717 21.9614381,18.3806937 C21.9614381,17.6692156 22.5258434,17.090405 23.2196144,17.090405 C23.9133855,17.090405 24.4777908,17.6692156 24.4777908,18.3806937 L24.4777908,19.6709823 Z M30.2686772,18.3806937 C30.2686772,17.6692156 30.8330826,17.090405 31.5273994,17.090405 C32.2211704,17.090405 32.7855758,17.6692156 32.7855758,18.3806937 C32.7855758,19.0921717 32.2211704,19.6709823 31.5273994,19.6709823 L30.2703147,19.6709823 L30.2686772,18.3806937 Z M29.7757777,36.0730426 L33.4165744,36.0730426 L33.4165744,43.0120529 L32.6671271,43.0120529 C32.6654895,43.0120529 32.663852,43.0114931 32.6616686,43.0114931 L22.089712,43.0120529 C22.0880745,43.0120529 22.0864369,43.0114931 22.0842536,43.0114931 L21.3298936,43.0120529 L21.3298936,36.0730426 L29.1715256,36.0730426 L29.7757777,36.0730426 Z M26.1153306,34.3937081 L26.1153306,21.3503169 L28.6355042,21.3503169 L28.654063,34.3937081 L26.1153306,34.3937081 Z M29.2315687,47.3206655 L25.5143535,47.3206655 C24.2927488,47.3206655 23.2671031,46.19887 22.9832629,44.6913874 L31.7621134,44.6913874 C31.4788191,46.19887 30.4531733,47.3206655 29.2315687,47.3206655 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VECTOR---Constructed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4859273,72 C95.7140031,83.0544491 81.9267715,103.639021 70.4859273,113 C59.0450831,122.360979 49.8516222,128.954609 40.4859273,124 C31.1202324,119.045391 67.9604482,93.9709491 60.4859273,73 C57.5501227,64.7631362 52.2486065,67.3874581 45.4859273,63 C35.0309124,56.2170463 19.7510594,48.3580784 20.2524498,35.5441565 C21.0781576,14.4417296 45.2686278,15.7518989 60.481623,18.5547847 C75.6946183,21.3576704 87.6477362,24.3419613 94.4859273,37 C101.324118,49.6580387 101.257851,60.9455509 98.4859273,72 Z",
    id: "Blob",
    fill: "#FDF0E9",
    transform: "translate(60.242964, 71.346857) scale(-1, 1) translate(-60.242964, -71.346857) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sparks",
    transform: "translate(24.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(60.000000, 75.000000)",
    fill: "#FCE8DE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  })), /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    transform: "translate(-0.000000, 89.000000)",
    fill: "#F3B08C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 6.22222222,
    y: 0,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 6.22222222,
    y: 9.33333333,
    width: 1.55555556,
    height: 4.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 6.22222222,
    y: 6.22222222,
    width: 1.55555556,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 9.33333333,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 6.22222222,
    width: 4.66666667,
    height: 1.55555556
  })), /*#__PURE__*/React.createElement("g", {
    id: "Spark",
    fill: "#F3B08C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 8,
    y: 0,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-3",
    x: 8,
    y: 12,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    x: 8,
    y: 8,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-2",
    x: 12,
    y: 8,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy-4",
    x: 0,
    y: 8,
    width: 6,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(32.625000, 45.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape-Copy-6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2.3,
    d: "M23.9387571,-0.812207619 C29.0830481,-1.83935049 34.3130287,-0.500841776 38.2859821,2.85683946 C42.2492765,6.20596951 44.5255832,11.1433553 44.525,16.4046767 C44.525,21.3110219 42.4934505,26.0255909 38.954981,29.3407002 C37.1944695,30.9901311 36.2041142,33.0986046 36.2041142,35.293345 L36.2041142,35.293345 L36.2035683,43.8517201 C36.2035683,44.3974917 35.9856465,44.8907058 35.6370227,45.2482274 C35.2780374,45.6163751 34.781423,45.8413874 34.2347985,45.8413874 L34.35,45.836 L34.3041789,45.9965582 C34.0190657,46.9164011 33.5577766,47.7326418 32.9752821,48.3889551 L32.7969526,48.5809949 C31.8349605,49.5708836 30.585511,50.15 29.2315687,50.15 L29.2315687,50.15 L25.5143535,50.15 C24.1604215,50.15 22.910808,49.5708738 21.9486675,48.5809615 C21.2817686,47.8948127 20.7548819,47.0083482 20.4412181,45.9965366 L20.395,45.836 L20.330195,45.8331633 C19.9142449,45.7950476 19.5348431,45.6262919 19.2328502,45.365604 L19.108283,45.248365 C18.7596807,44.8908654 18.541808,44.3976303 18.541808,43.8517201 L18.541808,43.8517201 L18.541808,35.4735988 C18.362668,32.9845018 17.4286135,30.8635306 15.8469254,29.3944228 C11.6043017,25.4533007 9.56839922,19.6056999 10.4128235,13.7467436 C10.9307915,10.1544875 12.5752689,6.86211998 14.9557957,4.29616666 C17.3448016,1.72107383 20.4729034,-0.120331929 23.9387571,-0.812207619 Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 0.3,
    d: "M37.6405372,3.62064626 C41.3803567,6.78093182 43.5255503,11.4407386 43.525,16.4046767 C43.525,21.0336627 41.6101342,25.4828436 38.2712712,28.6109461 C36.3772778,30.3854369 35.2965529,32.6382687 35.2097807,34.9864829 L35.2041142,35.2932812 L35.2035683,43.8517201 C35.2035683,44.1244279 35.0954027,44.3712965 34.9210628,44.5500861 C34.7746532,44.7002324 34.5816619,44.8024274 34.3664194,44.8323217 L34.2347985,44.8413874 L33.5483267,44.8413874 C33.3575912,46.0517694 32.8254623,47.1167931 32.0798129,47.8840654 C31.3662081,48.6183639 30.4575021,49.0805108 29.4626336,49.1427854 L29.2315687,49.15 L25.5143535,49.15 C24.4293422,49.15 23.4344064,48.6748166 22.6657618,47.8839853 C21.9773843,47.175738 21.4709329,46.2138086 21.2470703,45.1180467 L21.1970501,44.8413874 L20.5105779,44.8413874 C20.2425282,44.8413874 19.9998376,44.7303 19.824243,44.5502237 C19.6789544,44.4012268 19.579678,44.2049213 19.5506217,43.9857623 L19.541808,43.8517201 L19.541808,35.4383804 C19.3494186,32.6556206 18.2892336,30.2980822 16.5275195,28.6617622 C12.5220102,24.940904 10.6056278,19.4190854 11.4025875,13.8894578 C11.8911599,10.5010681 13.4436799,7.3963901 15.6888946,4.97628874 C17.9352379,2.55497093 20.8746872,0.819192134 24.1345588,0.168435889 C28.9767704,-0.798391839 33.9004071,0.459732094 37.6405372,3.62064626 Z M31.5773386,44.8413874 L23.1681023,44.8413874 L23.2323415,45.0834633 C23.3979203,45.6383235 23.6717237,46.1209991 24.0203967,46.4831981 C24.4327379,46.9115349 24.9502891,47.1706655 25.5143535,47.1706655 L25.5143535,47.1706655 L29.2315687,47.1706655 L29.4177946,47.1611906 C29.909373,47.1109869 30.3590381,46.863916 30.7255151,46.4831403 C31.1239079,46.0692036 31.4244607,45.4979268 31.5773386,44.8413874 L31.5773386,44.8413874 Z M33.2665744,36.2230426 L21.4798936,36.2230426 L21.4798936,42.8620529 L33.2665744,42.8620529 L33.2665744,36.2230426 Z M28.4857175,21.5003169 L26.2653306,21.5003169 L26.2653306,34.2437081 L28.5038494,34.2437081 L28.4857175,21.5003169 Z M23.2196144,17.240405 C22.9145069,17.240405 22.638065,17.3680449 22.4377561,17.5734662 C22.2360948,17.7802745 22.1114381,18.0658709 22.1114381,18.3806937 C22.1114381,18.6955164 22.2360948,18.9811128 22.4377561,19.1879211 C22.638065,19.3933424 22.9145069,19.5209823 23.2196144,19.5209823 L23.2196144,19.5209823 L24.3277908,19.5209823 L24.3277908,18.3806937 L24.3202977,18.2477035 C24.2906031,17.9858798 24.1743253,17.7507305 24.0014728,17.5734662 C23.8011639,17.3680449 23.524722,17.240405 23.2196144,17.240405 Z M31.5273994,17.240405 C31.2220546,17.240405 30.9454844,17.3680191 30.7451011,17.5734277 C30.5433521,17.7802362 30.4186772,18.0658498 30.4186772,18.3806937 L30.4186772,18.3806937 L30.4201245,19.5209823 L31.5273994,19.5209823 L31.6562664,19.513313 C31.9099366,19.4829264 32.1375645,19.3639965 32.3092577,19.1879211 C32.510919,18.9811128 32.6355758,18.6955164 32.6355758,18.3806937 C32.6355758,18.0658709 32.510919,17.7802745 32.3092577,17.5734662 C32.1089489,17.3680449 31.832507,17.240405 31.5273994,17.240405 Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 27.3749999,
    cy: 16.2021277,
    rx: 14.8518762,
    ry: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 20.6653226,
    y: 27.106383,
    width: 13.4193548,
    height: 16.6808511
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#C80000",
    x: 19.6330645,
    y: 35.4468085,
    width: 14.4516129,
    height: 8.34042553
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.891129,43.787234 C30.7416309,43.787234 33.0524193,46.0980224 33.0524193,48.9485243 L33.0524193,49 L33.0524193,49 L22.7298387,49 L22.7298387,48.9485243 C22.7298387,46.0980224 25.0406271,43.787234 27.891129,43.787234 Z",
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    transform: "translate(27.891129, 46.393617) scale(1, -1) translate(-27.891129, -46.393617) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5437204,3.73521728 C33.8385138,0.603818174 28.9608288,-0.642248041 24.163929,0.315532415 C17.7060181,1.60470155 12.5193839,7.19520618 11.5510521,13.9108649 C10.7612121,19.3910933 12.6596665,24.8640445 16.6296087,28.5518631 C18.4183479,30.2132847 19.4974866,32.6063364 19.6688824,35.2910325 C19.6721575,35.3397332 19.6814369,35.3867546 19.691808,35.4332162 L19.691808,43.8517201 C19.691808,44.3152165 20.058071,44.6913874 20.5105779,44.6913874 L21.3266185,44.6913874 C21.6590391,47.1314605 23.4079315,49 25.5143535,49 L29.2315687,49 C31.3379907,49 33.0863373,47.1314605 33.4187578,44.6913874 L34.2347985,44.6913874 C34.6867594,44.6913874 35.0535683,44.3152165 35.0535683,43.8517201 L35.0535683,35.2988694 C35.0535683,35.2971901 35.0541142,35.2955107 35.0541142,35.2932716 C35.0541142,32.7955414 36.1599994,30.3834573 38.1687148,28.501483 C41.4776368,25.4014315 43.375,20.9920588 43.375,16.4046767 C43.3755453,11.4853461 41.2500187,6.86717617 37.5437204,3.73521728 Z M24.4777908,19.6709823 L23.2196144,19.6709823 C22.5258434,19.6709823 21.9614381,19.0921717 21.9614381,18.3806937 C21.9614381,17.6692156 22.5258434,17.090405 23.2196144,17.090405 C23.9133855,17.090405 24.4777908,17.6692156 24.4777908,18.3806937 L24.4777908,19.6709823 Z M30.2686772,18.3806937 C30.2686772,17.6692156 30.8330826,17.090405 31.5273994,17.090405 C32.2211704,17.090405 32.7855758,17.6692156 32.7855758,18.3806937 C32.7855758,19.0921717 32.2211704,19.6709823 31.5273994,19.6709823 L30.2703147,19.6709823 L30.2686772,18.3806937 Z M29.7757777,36.0730426 L33.4165744,36.0730426 L33.4165744,43.0120529 L32.6671271,43.0120529 C32.6654895,43.0120529 32.663852,43.0114931 32.6616686,43.0114931 C32.6594852,43.0114931 32.6583935,43.0120529 32.6562101,43.0120529 L22.089712,43.0120529 C22.0880745,43.0120529 22.0864369,43.0114931 22.0842536,43.0114931 C22.0820702,43.0114931 22.0809785,43.0120529 22.0787951,43.0120529 L21.3298936,43.0120529 L21.3298936,36.0730426 L29.1715256,36.0730426 M26.1153306,34.3937081 L26.1153306,21.3503169 L28.6355042,21.3503169 L28.654063,34.3937081 L26.1153306,34.3937081 Z M29.2315687,47.3206655 L25.5143535,47.3206655 C24.2927488,47.3206655 23.2671031,46.19887 22.9832629,44.6913874 L31.7621134,44.6913874 C31.4788191,46.19887 30.4531733,47.3206655 29.2315687,47.3206655 Z M37.0644671,27.2621342 C34.9509492,29.2420696 33.6998688,31.7476367 33.4657006,34.3937081 L30.2910569,34.3937081 L30.273044,21.3503169 L31.5273994,21.3503169 C33.1240007,21.3503169 34.4231155,20.0180448 34.4231155,18.3806937 C34.4231155,16.7433425 33.1240007,15.4110704 31.5273994,15.4110704 C29.9302523,15.4110704 28.6311375,16.7433425 28.6311375,18.3818132 L28.632775,19.6709823 L26.1153306,19.6709823 L26.1153306,18.3806937 C26.1153306,16.7433425 24.8162157,15.4110704 23.2196144,15.4110704 C21.6230132,15.4110704 20.3238983,16.7433425 20.3238983,18.3806937 C20.3238983,20.0180448 21.6230132,21.3503169 23.2196144,21.3503169 L24.4777908,21.3503169 L24.4777908,34.3937081 L21.217995,34.3937081 C20.8708366,31.5920183 19.6546904,29.0954077 17.7283978,27.3069164 C14.1651113,23.9963883 12.4609783,19.0804164 13.1705789,14.1560478 C14.0390208,8.13283462 18.6879961,3.11946129 24.4761533,1.96351936 C28.792708,1.10258053 33.1758561,2.21989776 36.5011535,5.03110375 C39.8286342,7.84286952 41.7369144,11.9885867 41.7369144,16.4052365 C41.7380056,20.5218452 40.0344184,24.4794769 37.0644671,27.2621342 Z",
    id: "Shape",
    fill: "#38627F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1875,
    y1: 23.4375,
    x2: 0.375,
    y2: 26,
    id: "Line",
    stroke: "#F7A600",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.1875,
    y1: 15.8125,
    x2: 0.375,
    y2: 15,
    id: "Line-Copy",
    stroke: "#F7A600",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.1875,
    y1: 7.8125,
    x2: 2.375,
    y2: 5,
    id: "Line-Copy-5",
    stroke: "#F7A600",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.375,
    y1: 26,
    x2: 46.875,
    y2: 23.125,
    id: "Line-Copy-2",
    stroke: "#F7A600",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.375,
    y1: 14,
    x2: 46.875,
    y2: 15.125,
    id: "Line-Copy-3",
    stroke: "#F7A600",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.375,
    y1: 4,
    x2: 45.875,
    y2: 7.125,
    id: "Line-Copy-4",
    stroke: "#F7A600",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstructedIcon);
export default __webpack_public_path__ + "static/media/constructedIcon.3c05e69ad0448710a79ebd6cad39124c.svg";
export { ForwardRef as ReactComponent };